import React, { Component } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import Logout from "../auth/Logout";
import userManager from "../auth/oidcConfig";
import { jwtDecode } from "jwt-decode";
import TransferBadge from "./TransferBadge";
import { useTransferNotifications } from "../contexts/TransferNotificationsContext";

// Function component to use hooks
const TransferNavLink = () => {
  const { refreshPendingTransfers } = useTransferNotifications();

  // This function directly triggers a fetch of pending transfers
  const fetchPendingTransfers = async () => {
    try {
      console.log("📡 Fetching pending transfers from nav link...");
      const response = await fetch("/transfers/pending", {
        credentials: "include",
      });

      if (response.ok) {
        console.log("✅ Pending transfers fetched from nav link");
      }
    } catch (error) {
      console.error(
        "❌ Error fetching pending transfers from nav link:",
        error
      );
    }
  };

  const handleClick = (e) => {
    // Check if we're already on the transfers page
    if (window.location.pathname === "/view-pending-transfers") {
      // Prevent default navigation since we're already there
      e.preventDefault();
      // Force refresh of the transfers table when clicked
      refreshPendingTransfers();
      // Also directly fetch pending transfers
      fetchPendingTransfers();
      console.log(
        "🔄 NavMenu link clicked - forcing refresh of pending transfers"
      );
    } else {
      // We're navigating to the page, still refresh the badge
      refreshPendingTransfers();
    }
  };

  return (
    <NavLink
      tag={Link}
      className="text-white"
      to="/view-pending-transfers"
      onClick={handleClick}
    >
      View Pending Transfers
      <TransferBadge />
    </NavLink>
  );
};

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
      isAdmin: false, // Start as not admin by default
      userLoading: true, // Indicate that we're waiting for user data
    };
  }

  async componentDidMount() {
    this.checkUserRole();
  }

  async checkUserRole() {
    const user = await userManager.getUser();

    if (user && user.access_token) {
      const decodedToken = jwtDecode(user.access_token);
      const roles = decodedToken.role || [];
      const isAdmin = Array.isArray(roles)
        ? roles.includes("Admin")
        : roles === "Admin";

      this.setState({ isAdmin, userLoading: false });
    } else {
      // Retry after a short delay
      setTimeout(() => {
        this.checkUserRole();
      }, 1000); // Adjust delay as needed
    }
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const { isAdmin, userLoading } = this.state;

    if (userLoading) {
      // Optionally render a loading state, or return null to render nothing while loading
      return null; // Or a spinner/loading text if you prefer
    }

    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
          style={{ backgroundColor: "#005500" }}
          container
          light
        >
          <NavbarBrand tag={Link} to="/" className="text-white">
            Amnathrig
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={!this.state.collapsed}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="text-white" to="/">
                  Home
                </NavLink>
              </NavItem>

              <NavItem>
                <TransferNavLink />
              </NavItem>

              <NavItem>
                <NavLink tag={Link} className="text-white" to="/contact">
                  Contact
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="text-white">
                  <i className="fas fa-shield-alt me-1"></i>Security
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/encryption-settings">
                    <i className="fas fa-cog me-1"></i>Security Settings
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/password-reset">
                    <i className="fas fa-key me-1"></i>Change Encryption
                    Password
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              {isAdmin && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="text-white">
                    <i className="fas fa-user-shield me-1"></i>Admin
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem tag={Link} to="/user-management">
                      <i className="fas fa-users me-1"></i>User Management
                    </DropdownItem>
                    <DropdownItem tag={Link} to="/transfer-repair">
                      <i className="fas fa-wrench me-1"></i>Transfer Repair
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              <NavItem>
                <Logout />
              </NavItem>
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
